import React from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"
import { Web3FundManagementCard } from "./Web3FundManagementCard"
import type { Web3FundManagementCardSection } from "@/common/data/Products"

export interface Web3FundManagementCardListProps {
  cards: Web3FundManagementCardSection[]
}

export function Web3FundManagementCardList({
  cards
}: Web3FundManagementCardListProps) {
  return (
    <LayoutWrapper className="kg-wrapper">
      {cards.map(card => (
        <Web3FundManagementCard key={card} cardName={card} type={card} />
      ))}
    </LayoutWrapper>
  )
}

const LayoutWrapper = styled.section`
  display: flex;
  align-items: flex-start;
  gap: 42px;
  align-self: stretch;

  @media (${theme.lg}) {
    flex-direction: column;
  }
`
